<template>
  <div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="trustedHtml"
      ref="contentbox"
      :class="computedContentClasses"
      v-html="trimmedContent"
    />
    <!-- eslint-enable vue/no-v-html -->
    <div
      v-else
      ref="contentbox"
      :class="computedContentClasses"
    >
      {{ trimmedContent }}
    </div>

    <div
      v-if="showExpander"
      class="mt-4 h-6"
    >
      <TButton
        :variant="moreButtonVariant"
        @click="expanded = !expanded"
      >
        {{ buttonText }}
      </TButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ButtonVariant } from '~/components/_tailwind/button/types'

const props = withDefaults(defineProps<{
  content: string
  lineClamp?: 10 | 3
  trustedHtml?: boolean
  isShowMoreButton?: boolean
  moreButtonVariant?: ButtonVariant
}>(), {
  lineClamp: 3,
  moreButtonVariant: 'highlight',
})

const { t } = useI18n()
const { isSafari } = useDevice()

const contentbox = useTemplateRef('contentbox')
const expanded = ref(false)

const trimmedContent = computed(() => props.content.trim())

const lineClampClass = computed(() => {
  if (props.lineClamp === 10) return 'line-clamp-10'
  return 'line-clamp-3'
})

const computedContentClasses = computed(() => [
  'whitespace-pre-line wrap-anywhere vhtml-link-muted vhtml-paragraph-spacing',
  {
    'vhtml-paragraph-safari-fix': isSafari,
    [lineClampClass.value]: !expanded.value,
  },
])

const showExpander = computed(() => {
  return (
    props.content.split(/\r\n|\r|\n/).length > props.lineClamp
    || (contentbox.value?.scrollHeight || 0) > (contentbox.value?.clientHeight || 0)
  )
})

const buttonText = computed(() => {
  if (props.isShowMoreButton) {
    return expanded.value ? t('actions.showLess') : t('actions.showMore')
  }
  return expanded.value ? t('actions.readLess') : t('actions.readMore')
})
</script>
